<template>
    <div class="main-header__user">
        <template v-if="isLoggedIn">
            <template v-if="isMobile">
                <HeaderMyTickets />
                <MainHeaderButton icon="account" @click="showMyAccount">
                    {{ displayBalance }}
                </MainHeaderButton>
            </template>
            <template v-else-if="isMdLarger">
                <HeaderLoggedDuration class="main-header__logged-duration">PŘIHLÁŠEN</HeaderLoggedDuration>
                <div class="main-header__spacer"></div>
                <HeaderMyTickets />
                <div class="main-header__spacer"></div>
                <template v-if="isLaptopLarger">
                    <MainHeaderButton
                        class="main-header-button--deposit"
                        icon="deposit"
                        @click="showDeposit"
                    >
                        VKLAD
                    </MainHeaderButton>
                    <div class="main-header__spacer"></div>
                </template>                
                <MainHeaderButton
                    :active="isMenuVisible"
                    class="main-header-button--profile"
                    icon="account"
                    @click="toggleProfileMenu"
                >
                    {{ session.PlayerName.toUpperCase() }}
                    <template #subtext v-if="headerStore.displayBalance">{{ displayBalance }}</template>
                </MainHeaderButton>
            </template>
            <button
                class="main-header__profile"
                :class="{ 'main-header__profile--active': isMenuVisible }"
                v-else
                @click="toggleProfileMenu"
            >
                <div>
                    <div class="main-header__profile__name">
                        <div class="main-header__profile__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="21"
                                stroke="currentColor"
                                fill="none"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            >
                                <path
                                    d="M13.8 7.4c0 3.535-2.15 6.4-4.8 6.4s-4.8-2.865-4.8-6.4S6.35 1 9 1s4.8 2.866 4.8 6.4z"
                                ></path>
                                <path
                                    d="M12.936 14.262c2.236 0 4.064 1.764 4.064 3.92 0 .778-.66 1.413-1.465 1.413H2.465C1.66 19.596 1 18.96 1 18.182c0-2.156 1.83-3.92 4.064-3.92"
                                    stroke-linecap="round"
                                ></path>
                            </svg>
                        </div>
                        {{ profileText }}
                    </div>
                    <HeaderLoggedDuration class="main-header__logged-duration">Přihlášen</HeaderLoggedDuration>
                </div>
                <SvgIcon name="arrow-down" :size="28" />
            </button>
        </template>
        <template v-else>
            <MainHeaderButton v-if="isMobile" icon="account" @click="showLogin">PŘIHLÁSIT</MainHeaderButton>
            <div class="main-header__buttons" v-else>
                <a :href="registrationLink" class="main-header__register"> Vytvořit účet </a>
                <button class="main-header__login" @click="showLogin">Přihlásit</button>
            </div>
        </template>
    </div>
    <MainHeaderMenu v-if="isLoggedIn" v-model="isMenuVisible" />
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import MainHeaderButton from "@/header/components/atoms/MainHeaderButton.vue";
import HeaderMyTickets from "@/header/components/atoms/HeaderMyTickets.vue";
import HeaderLoggedDuration from "@/header/components/atoms/HeaderLoggedDuration.vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import MainHeaderMenu from "@/header/components/molecules/MainHeaderMenu.vue";
import { ngFrameworkLoaded } from "@/shared/ng/ng-integration";
import { useNgSession } from "@/shared/ng/ng-session";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { useHeader } from "@/shared/stores/use-header";
import { logException } from "@/shared/utils/logger/use-app-logger";

const { balance, isLoggedIn, session } = useNgSession();

const { isMobile, isMdLarger, isLaptopLarger } = useIsBreakpoint();

const headerStore = useHeader();
const isMenuVisible = ref(false);

const displayBalance = computed(() => balance.value.DisplayBalance);

const profileText = computed(() =>
    headerStore.displayBalance ? displayBalance.value : session.value.PlayerName.toUpperCase(),
);

watch(isLoggedIn, () => (isMenuVisible.value = false));

const showMyAccount = async () => {
    try {
        await ngFrameworkLoaded();

        ng_fw.showMyAccount();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while opening My Account" });
    }
};

const showLogin = async () => {
    try {
        await ngFrameworkLoaded();

        ng_fw.showLogin();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while opening Login" });
    }
};

const showDeposit = async () => {
    try {
        await ngFrameworkLoaded();

        ng_fw.showDeposit();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while opening Deposit" });
    }
};

const toggleProfileMenu = () => {
    isMenuVisible.value = !isMenuVisible.value;
};

const registrationLink = `${environment.portalBaseUrl}/registrace?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
</script>
